export default __webpack_public_path__ + "static/media/assess-walk-3.e2c64775.gif";